import { mapActions, mapState } from 'vuex';

export default {
    computed: {
        ...mapState('payment', ['paymentList']),

        paymentLoading() {
            return this.onLoading('fetch-payment');
        },
    },

    methods: {
        ...mapActions('payment', [
            'findPayments',
            'getPaymentList',
            'getPaymentListIfNecessary',
        ]),

        refreshPaymentList: _.debounce(function(query) {
            this.getPaymentListIfNecessary({ query: query });
        }, 500),
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/payments.js